import { useSyncExternalStore } from 'react';
import { IMPERSONATION_FLAG } from '@/lib/impersonation-bootstrap.js';

function read(): boolean {
  try {
    return (
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem(IMPERSONATION_FLAG) === '1'
    );
  } catch {
    return false;
  }
}

// The flag is written once at boot by impersonation-bootstrap and cleared only
// when the tab closes, so it never changes during a tab's lifetime. We still
// subscribe to the cross-tab `storage` event so a `clear()` in this or another
// tab re-renders consumers without a full reload.
function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener('storage', onChange);
  return () => window.removeEventListener('storage', onChange);
}

export function useIsImpersonating(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
